import React, { useEffect, useState, forwardRef, useRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TextField } from '@material-ui/core';
import { toast } from 'react-toastify';
import { updateTag as updating } from '../../actions/admin/tagAction';
import OverLoading from '../global/OverLoading';

const FormCreate = forwardRef((props, ref) => {
  const submitButtonRef = useRef();
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    submitForm() {
      submitButtonRef.current.click();
    },
  }));

  const [formData, setFormData] = useState({
    nameZh: '',
  });
  const { nameZh } = formData;

  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await props.updating({ name: formData.name, nameZh: formData.nameZh }).then((response) => {
        if (response.status === 200) {
          toast.success('Name (Chinese Zh) updated.');
          props.updateList();
        } else {
          toast.error('An unexpected error has occurred');
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (props.updateTag) {
      setFormData(props.updateTag);
    }
  }, [props.updateTag]);

  return (
    <>
      <form onSubmit={(e) => onSubmit(e)}>
        {loading && <OverLoading />}
        <div className="form-group">
          <p>Name (Chinese Zh)</p>
          <TextField name="nameZh" className="form-control" value={nameZh} multiline onChange={(e) => onChange(e)} />
        </div>
        <div className="form-group">
          <input
            type="submit"
            className="btn btn-primary mr-1 d-none"
            value="Save"
            ref={submitButtonRef}
          />
        </div>
      </form>
    </>
  );
});

FormCreate.propTypes = {
  updateTag:  PropTypes.shape({}).isRequired,
  updateList: PropTypes.func.isRequired,
  updating:   PropTypes.func.isRequired,
};

export default connect(null, { updating }, null, {
  forwardRef: true,
}) (FormCreate);
